import { ListPicker } from "../../../components/generic/ListPicker";
import { usePickerhook } from "../../../hooks/usePickerhook";
import { Fragment, ReactNode, useEffect, useState } from "react";
import useDepartmentHook from "../../../hooks/useDepartmentHook";
import useEmployeeHook from "../../../hooks/useEmployeeHook";
import usePositionHook from "../../../hooks/usePositionHook";
import { useStateSetter } from "../../../hooks/statehooks/UseStateSettersHook";
import { useStateGetter } from "../../../hooks/statehooks/UseStateGettersHook";
 import { BsCalendar, BsGrid, BsPersonFillDash } from "react-icons/bs";
  
 
import { TbDashboard } from "react-icons/tb";
  
import EmployeeApplisting from "./Leave/EmployeeApplisting";
import useEmplAppHook from "../../../hooks/useEmplAppHook";

export default () => {
  const departmentPicked = usePickerhook();
  const statusPicked = usePickerhook();
  const positionPicked = usePickerhook();
  const { selectedOrgEmployees } = useEmployeeHook();
  const [renderedlist, setrenderedlist] = useState(selectedOrgEmployees);
  const { selectedOrgDepts } = useDepartmentHook();
  const { allorgPositions } = usePositionHook();

  const { allempappraisal, getemployeeAppr } = useEmplAppHook();

  const tabs = [
    { icon: <BsGrid className=" inline mr-1" />, title: "Grid" },
    { icon: <BsCalendar className=" inline  mr-1 " />, title: "Calender" },
    { icon: <TbDashboard className=" inline  mr-1" />, title: "Dashboard" },
  ];

  const tabViews = [
    <EmployeeApplisting
      refresh={getemployeeAppr}
      appraisals={allempappraisal}
      isAdminview={true}
      setshowaddleavemodal={() => {}}
    />,
    <></>,
    <></>,
  ];

  const [selectedTabview, setselectedTabview] = useState<JSX.Element>(
    tabViews[0]
  );
  const ActionItem2 = ({ title, icon, key_ }: any) => (
    <div
      onClick={() => {
        setselectedTabview(tabViews[key_]);
        setselectedTab(title);
      }}
      className={`m-1 rounded-[8px] p-2  font-semibold ${
        selectedTab == title
          ? "bg-textbg text-white"
          : " bg-faintBlue text-blueGray "
      }`}
    >
      <p className="  cursor-pointer text-xs flex justify-center items-center ">
        {icon}
        {title}
      </p>
    </div>
  );

  const [selectedTab, setselectedTab] = useState(tabs[0].title);
  const { authuser } = useStateGetter();
  const [showadd, setshowadd] = useState(false);
  const { setselectedEmpl, setSidebarRenderView, setShowModal } =
    useStateSetter();
  const [entered, setentered] = useState("");
  const [target, setTarget] = useState("");
  return (
    <div className="w-full   flex  ">
      <div
        className={` p-6 bg-white   h-screen pb-40 w-full  rounded-[20px] overflow-y-scroll `}
      >
        <div className="  w-full  flex gap-4 items-center   ">
          <p className="text-textbg font-medium  mb-2   bg-white">
            Appraisal ({allempappraisal.length})
          </p>
          <div className="border border-gray-300 p-1 flex rounded-md  ">
            {tabs.map((it, key) => (
              <ActionItem2 key_={key} {...it} />
            ))}
          </div>
        </div>
        <div className="w-full flex justify-between items-center">
          <div className="flex  gap-4">
            <ListPicker
              hook={statusPicked}
              notitle
              title="All status"
              list={[
                { code: "pending", name: "Pending" },
                { code: "approved", name: "Approved" },
                { code: "cancelled", name: "Cancelled" },
                { code: "rejected", name: "Rejected" },
              ]}
            />

            <ListPicker
              hook={departmentPicked}
              notitle
              title="Department"
              list={
                selectedOrgDepts
                  ? selectedOrgDepts?.map((i) => {
                      return { name: i.deptName, code: i.id };
                    })
                  : []
              }
            />
            <ListPicker
              hook={positionPicked}
              notitle
              title="Position"
              list={
                allorgPositions
                  ? allorgPositions?.map((i: any) => {
                      return { name: i.positionTitle, code: i.id };
                    })
                  : []
              }
            />
          </div>
        </div>
        <EmployeeApplisting
          refresh={getemployeeAppr}
          appraisals={allempappraisal}
          isAdminview={true}
          setshowaddleavemodal={() => {
            
          }}
        />
      </div>
    </div>
  );
};
